import { Component, Injector, Optional } from "@angular/core";
import { VDialogRef } from "@app/directives/_layout/v-dialog/v-dialog-ref";
import { ColourService } from "@app/services/colour.service";
import { CurrentUserService } from "@app/services/currentUser.service";
import "./nps-rater.component.scss";
import { INPSEntry, NPSService } from "./nps.service";

@Component({
    selector: "nps-rater",
    template: require("./nps-rater.component.html"),
})
export class NPSRaterComponent {

    selectedRating: number;
    comments: string;
    saving: boolean;
    showThankYou: boolean;

    constructor(
        private readonly injector: Injector,
        @Optional() private ref: VDialogRef,
        private readonly currentUserService: CurrentUserService,
        private readonly colourService: ColourService) {
    }

    selectRating(rating: number) {
        this.selectedRating = rating;
    }

    getColor(rating: number) {
        if (rating >= 9) {
            return this.colourService.greenColor;
        }

        if (rating >= 7) {
            return this.colourService.orangeColor;
        }

        return this.colourService.redColor;
    }

    submitEntry() {
        const userDescription = this.currentUserService.cachedUser.CurrentAccountUserMapping.Name || this.currentUserService.cachedUser.Email;
        const entry: INPSEntry = {
            PlatformId: "AST-Verilocation",
            CustomerId: this.currentUserService.cachedUser.CurrentAccountUserMapping.AccountId.toString(),

            UserDescription: userDescription,
            UserId: this.currentUserService.cachedUser.Id.toString(),

            Score: this.selectedRating,
            Comments: this.comments
        };

        this.saving = true;

        const npsService = this.injector.get(NPSService);
        npsService.submitRating(entry).subscribe(x => {
            this.saving = false;
            this.showThankYou = true;

            setTimeout(() => {
                this.ref?.close(entry);
            }, 2_000)
        });
    }
}
